import React from 'react'
import styles from './email.jcss'
import translate from '../../../../core/translate'
import Checkbox from '../../../../blocks.simple/checkbox/checkbox'
import Icon from '../../../../blocks.simple/icon/icon'
import moment from 'moment'
import AnimationWrapper from 'blocks.app/animationWrapper/animationWrapper'

export interface IEmail {
    id: number
    from: string
    to: string
    message: { html: string; subject: string }
    status: string
    error: string
    transport: string
    statusUpdatedAt: string
}

export const Email = ({ email, selected, onSelect, onDetails, getStatus }: any) => {
    return (
        <AnimationWrapper>
            <div className={styles.tableRow} role="row">
                <div className={styles.checkboxCell} role="cell">
                    <Checkbox
                        onClick={(selected: boolean) => {
                            onSelect(email.id, selected)
                        }}
                        checked={selected}
                    />
                </div>
                <div className={styles.dateCell} role="cell">
                    <span>{moment(email.statusUpdatedAt).format('DD.MM.YYYY')}</span>
                    <span>{moment(email.statusUpdatedAt).format('HH:mm:ss')}</span>
                </div>
                <div className={styles.statusCell} role="cell">
                    <img
                        className={styles.statusIcon}
                        src={`images/notification-center/email/${email.status}.svg`}
                        alt=""
                    />
                    <span>{getStatus(email.status)}</span>
                </div>
                <div className={styles.addressCell} role="cell">
                    {email.from}
                </div>
                <div className={styles.subjectCell} role="cell">
                    <span className={styles.subject}>{email.message.subject}</span>
                    <span className={styles.recipient}>
                        {translate('mailTo')}: {email.to}
                    </span>
                </div>
                <button
                    type="button"
                    className={styles.detailsButton}
                    aria-label={translate('moreDetails')}
                    onClick={() => onDetails(email)}
                >
                    <Icon type={'arrow_right'} size={16} />
                </button>
            </div>
        </AnimationWrapper>
    )
}
